module.exports = __webpack_public_path__ + "static/media/paypal-logo.fe820d8b.png";